import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  input,
  output
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

import { FileData } from '@shared/models/catalog.service';
import { CatalogItemCardFilesModalComponent } from '../catalog-item-card-info/components/catalog-item-card-files-modal/catalog-item-card-files-modal.component';

@Component({
  selector: 'app-download-link-list',
  templateUrl: './download-link-list.component.html',
  styleUrl: './download-link-list.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DownloadLinkListComponent {
  allFiles = input.required<FileData[]>();
  fileIds = input.required<string>();
  width = input.required<string>();
  onRowClick = output<MouseEvent | null>();
  fileIdsArray = computed(() => this.fileIds()?.split(';'));
  isMultiple = computed(() => this.fileIdsArray()?.length > 1);
  dialog = inject(MatDialog);

  getFileData(fileId: string): FileData | undefined {
    return this.allFiles()?.find(file => file.id === fileId);
  }

  getAllFilesData(): FileData[] {
    return this.fileIdsArray()?.map(fileId => this.getFileData(fileId)).filter(Boolean) as FileData[] || [];
  }

  openFilesInfo(event?: MouseEvent) {
    event?.stopImmediatePropagation();
    const filesData = this.getAllFilesData();
    this.dialog.open(
      CatalogItemCardFilesModalComponent,
      {
        backdropClass: 'closer-backdrop-transparent',
        data: filesData,
      });
    this.onRowClick.emit(event || null);
  }
}
